import { Close, Edit } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { I18n } from 'common'
import { useResultsStore } from '../../store/ResultsStore'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import { defaultTheme } from '../../../../../src/theme/index'
import styled from 'styled-components'

interface SelectLinesProps {
  resetSelection: () => void
}

export const SelectedLines = observer(
  (props: SelectLinesProps): ReactElement => {
    const { resetSelection } = props

    const { setShowFilterLinesDrawer } = useUiStateStore()
    const {
      selectedLinesManufacturers,
      setSelectedLinesManufacturers,
      setShowAllLinesForOrangeParts,
    } = useResultsStore()

    const handleClearSelection = (obj: string) => {
      setSelectedLinesManufacturers(
        selectedLinesManufacturers.filter((item) => item !== obj)
      )
      if (selectedLinesManufacturers.length === 1) {
        resetSelection()
      }
    }

    return (
      <Wrapper>
        <HeaderWrapper>
          <I18n name="selectedLines" style={{ fontWeight: 'bold' }} />
          <EditButton onClick={() => setShowFilterLinesDrawer(true)}>
            <Edit style={{ marginRight: 5, width: 15 }} />
            <I18n name="edit" style={{ fontSize: '14px' }} />
          </EditButton>
          <ClearButton
            onClick={() => {
              setSelectedLinesManufacturers([])
              resetSelection()
              setShowAllLinesForOrangeParts(false)
            }}
          >
            <I18n name="clearAll" style={{ fontSize: '14px' }} />
          </ClearButton>
        </HeaderWrapper>
        {selectedLinesManufacturers.map((selectionItem) => {
          return (
            <DivWrapper key={selectionItem}>
              <Close
                style={{ color: '#000000', cursor: 'pointer', marginRight: 10 }}
                fontSize="small"
                onClick={() => {
                  handleClearSelection(selectionItem)
                }}
              />
              <StyledItem>{selectionItem}</StyledItem>
            </DivWrapper>
          )
        })}
      </Wrapper>
    )
  }
)

SelectedLines.displayName = 'SelectedLines'

const StyledItem = styled.span`
  overflow-wrap: anywhere;
`

const Wrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  margin-bottom: 15px;
  justify-content: space-between;
`

const DivWrapper = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f3f2ee;
  display: flex;
  flex-direction: row;
  padding: 6px 10px;
  font-size: 15px;
  border-radius: 5px;
  font-weight: 500;
`

const EditButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${defaultTheme.colors.blueLight};
`

const ClearButton = styled.div`
  color: ${defaultTheme.colors.blueLight};
  cursor: pointer;
  align-items: center;
`
